import events from './events'
import login from './login'
import user from './user'
export default {
  events,
  login,
  user,
}
